import http from "@/settings/apiSettings";

class CrmTipuriActivitatiDataService {
  
  save(data: any): Promise<any> {
    return http.clientComercialOdata.post("/CRM_CautareTipuriActivitati", data);
  }

}

export default new CrmTipuriActivitatiDataService();
